<template>
  <div>
    <dialog id="start-activity-modal">
      <svg @click="closeModal('start-activity-modal'); tableActivityStartObject = null; startActivityChildInput = ''" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
      <div v-if="tableActivityStartObject">
        <div class="header-container">
          <img v-if="tableActivityStartObject.image" :src="`${reverseProxy}/api/${tableActivityStartObject.image}`" alt="Picture N/A" loading="lazy"/>
          <div>
            <h3>{{ tableActivityStartObject.title }}</h3>
            <p v-if="tableActivityStartObject.purchase_type == 'unit'">{{ tableActivityStartObject.units_purchased - tableActivityStartObject.units_used }} units left</p>
          </div>
        </div>
        <div>Select child/patient<span style="color: red;">*</span> </div>
        <select v-model="startActivityChildInput">
          <option value="" selected disabled>Search for child/patient</option>
          <option v-for="(child, index) in childrenList" :key="index" :value="child.child_id">
            {{ `${child.first_name} ${child.last_name}` }}
          </option>
        </select>
        <router-link to="/dashboard">Add New Child</router-link>
        <div>
          <button @click="startNewActivity" class="black-button-soft-rect-global long-button">Start Activity</button>
        </div>
      </div>
    </dialog>
    <dialog id="resume-activity-modal">
      <svg @click="closeModal('resume-activity-modal'); tableActivityResumeObject = null" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
      <div v-if="tableActivityResumeObject">
        <div class="header-container">
          <img v-if="tableActivityResumeObject.image" :src="`${reverseProxy}/api/${tableActivityResumeObject.image}`" alt="Picture N/A" loading="lazy"/>
          <div>
            <h3>{{ tableActivityResumeObject.title }}</h3>
            <!-- <progress id="file" value="25" max="100"></progress> -->
          </div>
        </div>
        <div class="info-grid">
          <div class="columnName">CHILD / PATIENT</div>
          <div class="columnName">DATED STARTED</div>
          <div>
            <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15 8C15 9.06087 14.5786 10.0783 13.8284 10.8284C13.0783 11.5786 12.0609 12 11 12C9.93913 12 8.92172 11.5786 8.17157 10.8284C7.42143 10.0783 7 9.06087 7 8C7 6.93913 7.42143 5.92172 8.17157 5.17157C8.92172 4.42143 9.93913 4 11 4C12.0609 4 13.0783 4.42143 13.8284 5.17157C14.5786 5.92172 15 6.93913 15 8ZM13 8C13 8.53043 12.7893 9.03914 12.4142 9.41421C12.0391 9.78929 11.5304 10 11 10C10.4696 10 9.96086 9.78929 9.58579 9.41421C9.21071 9.03914 9 8.53043 9 8C9 7.46957 9.21071 6.96086 9.58579 6.58579C9.96086 6.21071 10.4696 6 11 6C11.5304 6 12.0391 6.21071 12.4142 6.58579C12.7893 6.96086 13 7.46957 13 8Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM2 11C2 13.09 2.713 15.014 3.908 16.542C4.74744 15.4401 5.83015 14.5471 7.07164 13.9327C8.31312 13.3183 9.6798 12.9991 11.065 13C12.4324 12.9984 13.7821 13.3091 15.0111 13.9084C16.2402 14.5077 17.3162 15.3797 18.157 16.458C19.0234 15.3216 19.6068 13.9952 19.8589 12.5886C20.111 11.182 20.0244 9.73553 19.6065 8.36898C19.1886 7.00243 18.4512 5.75505 17.4555 4.73004C16.4598 3.70503 15.2343 2.93186 13.8804 2.47451C12.5265 2.01716 11.0832 1.88877 9.66986 2.09997C8.25652 2.31117 6.91379 2.85589 5.75277 3.68905C4.59175 4.52222 3.64581 5.61987 2.99323 6.8912C2.34065 8.16252 2.00018 9.57097 2 11ZM11 20C8.93391 20.0033 6.93014 19.2926 5.328 17.988C5.97281 17.0646 6.83119 16.3107 7.83008 15.7905C8.82896 15.2702 9.93876 14.999 11.065 15C12.1772 14.999 13.2735 15.2635 14.263 15.7713C15.2524 16.2792 16.1064 17.0158 16.754 17.92C15.1395 19.267 13.1026 20.0033 11 20Z" fill="black"/>
            </svg>
            {{ `${tableActivityResumeObject.first_name} ${tableActivityResumeObject.last_name}` }}
          </div>
          <div>
            {{ formatTimestamp(tableActivityResumeObject.start_date) }}
          </div>
        </div>
        <div>
          <button @click="resumeActivityButton" class="black-button-soft-rect-global long-button">Resume Activity</button>
        </div>
      </div>
    </dialog>
    <dialog id="completed-activity-modal">
      <svg @click="closeModal('completed-activity-modal'); tableActivityCompletedObject = null" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
      <div v-if="tableActivityCompletedObject">
        <div class="header-container">
          <img v-if="tableActivityCompletedObject.image" :src="`${reverseProxy}/api/${tableActivityCompletedObject.image}`" alt="Picture N/A" loading="lazy"/>
          <div>
            <h3>{{ tableActivityCompletedObject.title }}</h3>
          </div>
        </div>
        <div class="info-grid">
          <div class="columnName">CHILD / PATIENT</div>
          <div class="columnName">DATED STARTED</div>
          <div class="columnName">DATED FINISH</div>
          <div>
            <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15 8C15 9.06087 14.5786 10.0783 13.8284 10.8284C13.0783 11.5786 12.0609 12 11 12C9.93913 12 8.92172 11.5786 8.17157 10.8284C7.42143 10.0783 7 9.06087 7 8C7 6.93913 7.42143 5.92172 8.17157 5.17157C8.92172 4.42143 9.93913 4 11 4C12.0609 4 13.0783 4.42143 13.8284 5.17157C14.5786 5.92172 15 6.93913 15 8ZM13 8C13 8.53043 12.7893 9.03914 12.4142 9.41421C12.0391 9.78929 11.5304 10 11 10C10.4696 10 9.96086 9.78929 9.58579 9.41421C9.21071 9.03914 9 8.53043 9 8C9 7.46957 9.21071 6.96086 9.58579 6.58579C9.96086 6.21071 10.4696 6 11 6C11.5304 6 12.0391 6.21071 12.4142 6.58579C12.7893 6.96086 13 7.46957 13 8Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM2 11C2 13.09 2.713 15.014 3.908 16.542C4.74744 15.4401 5.83015 14.5471 7.07164 13.9327C8.31312 13.3183 9.6798 12.9991 11.065 13C12.4324 12.9984 13.7821 13.3091 15.0111 13.9084C16.2402 14.5077 17.3162 15.3797 18.157 16.458C19.0234 15.3216 19.6068 13.9952 19.8589 12.5886C20.111 11.182 20.0244 9.73553 19.6065 8.36898C19.1886 7.00243 18.4512 5.75505 17.4555 4.73004C16.4598 3.70503 15.2343 2.93186 13.8804 2.47451C12.5265 2.01716 11.0832 1.88877 9.66986 2.09997C8.25652 2.31117 6.91379 2.85589 5.75277 3.68905C4.59175 4.52222 3.64581 5.61987 2.99323 6.8912C2.34065 8.16252 2.00018 9.57097 2 11ZM11 20C8.93391 20.0033 6.93014 19.2926 5.328 17.988C5.97281 17.0646 6.83119 16.3107 7.83008 15.7905C8.82896 15.2702 9.93876 14.999 11.065 15C12.1772 14.999 13.2735 15.2635 14.263 15.7713C15.2524 16.2792 16.1064 17.0158 16.754 17.92C15.1395 19.267 13.1026 20.0033 11 20Z" fill="black"/>
            </svg>
            {{ `${tableActivityCompletedObject.first_name} ${tableActivityCompletedObject.last_name}` }}
          </div>
          <div>
            {{ formatTimestamp(tableActivityCompletedObject.start_date) }}
          </div>
          <div>
            {{ formatTimestamp(tableActivityCompletedObject.finish_date) }}
          </div>
        </div>
        <div>
          <button @click="completedActivityButton" class="black-button-soft-rect-global long-button">See Report</button>
        </div>
      </div>
    </dialog>
    <div id="activities-container">
      <div id="sidebar-box">
<!--         <div class="side-nav-back">
          <svg viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538407 7.04738 0.538407 6.65686 0.928931L0.292893 7.29289ZM15 7L1 7L1 9L15 9L15 7Z" fill="black"/>
          </svg>
          Activities
        </div> -->
        <div style="margin-top: 1rem;" @click="changeTab('startActivity')" class="side-nav" :class="[currentTab == 'startActivity' ? 'activeTab' : null]">Start Activity</div>
        <div @click="changeTab('resumeActivity')" class="side-nav" :class="[currentTab == 'resumeActivity' ? 'activeTab' : null]">Resume Activity</div>
        <div @click="changeTab('completedActivity')" class="side-nav" :class="[currentTab == 'completedActivity' ? 'activeTab' : null]">Completed Activity</div>
      </div>
      <div id="main-box" v-if="purchasesData && activityResumeList && activityCompletedList">
        <div v-if="currentTab == 'startActivity'">
          <h2>Start an Activity</h2>
          <div class="activities-grid-start">
            <article v-for="(app, index) in purchasesData" class="start-activity-container" :key="index" @click="openModal('start-activity-modal'); tableActivityStartObject = app">
              <img v-if="app.image" :src="`${reverseProxy}/api/${app.image}`" alt="Picture N/A" loading="lazy"/>
              <h6>{{ app.title }}</h6>
              <p v-if="app.purchase_type == 'unit'">{{ app.units_purchased - app.units_used }} Units Left</p>
              <p v-else-if="app.purchase_type == 'monthly'">Monthly Subscription</p>
              <p v-else-if="app.purchase_type == 'free'">Free</p>
            </article>
          </div>
        </div>
        <div v-else-if="currentTab == 'resumeActivity'">
          <h2>Resume Activity</h2>
          <div class="activities-grid-resume">
            <article v-for="(app, index) in activityResumeList" class="resume-activity-container" :key="index" @click="openModal('resume-activity-modal'); tableActivityResumeObject = app">
              <div>
                <img v-if="app.image" :src="`${reverseProxy}/api/${app.image}`" alt="Picture N/A" loading="lazy"/>
              </div>
              <div>
                <div style="display: flex; align-items: center; column-gap: 5px;">
                  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 8C15 9.06087 14.5786 10.0783 13.8284 10.8284C13.0783 11.5786 12.0609 12 11 12C9.93913 12 8.92172 11.5786 8.17157 10.8284C7.42143 10.0783 7 9.06087 7 8C7 6.93913 7.42143 5.92172 8.17157 5.17157C8.92172 4.42143 9.93913 4 11 4C12.0609 4 13.0783 4.42143 13.8284 5.17157C14.5786 5.92172 15 6.93913 15 8ZM13 8C13 8.53043 12.7893 9.03914 12.4142 9.41421C12.0391 9.78929 11.5304 10 11 10C10.4696 10 9.96086 9.78929 9.58579 9.41421C9.21071 9.03914 9 8.53043 9 8C9 7.46957 9.21071 6.96086 9.58579 6.58579C9.96086 6.21071 10.4696 6 11 6C11.5304 6 12.0391 6.21071 12.4142 6.58579C12.7893 6.96086 13 7.46957 13 8Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM2 11C2 13.09 2.713 15.014 3.908 16.542C4.74744 15.4401 5.83015 14.5471 7.07164 13.9327C8.31312 13.3183 9.6798 12.9991 11.065 13C12.4324 12.9984 13.7821 13.3091 15.0111 13.9084C16.2402 14.5077 17.3162 15.3797 18.157 16.458C19.0234 15.3216 19.6068 13.9952 19.8589 12.5886C20.111 11.182 20.0244 9.73553 19.6065 8.36898C19.1886 7.00243 18.4512 5.75505 17.4555 4.73004C16.4598 3.70503 15.2343 2.93186 13.8804 2.47451C12.5265 2.01716 11.0832 1.88877 9.66986 2.09997C8.25652 2.31117 6.91379 2.85589 5.75277 3.68905C4.59175 4.52222 3.64581 5.61987 2.99323 6.8912C2.34065 8.16252 2.00018 9.57097 2 11ZM11 20C8.93391 20.0033 6.93014 19.2926 5.328 17.988C5.97281 17.0646 6.83119 16.3107 7.83008 15.7905C8.82896 15.2702 9.93876 14.999 11.065 15C12.1772 14.999 13.2735 15.2635 14.263 15.7713C15.2524 16.2792 16.1064 17.0158 16.754 17.92C15.1395 19.267 13.1026 20.0033 11 20Z" fill="black"/>
                  </svg>
                  <span>{{ `${app.first_name} ${app.last_name}` }}</span>
                </div>
                <h5>{{ app.title }}</h5>
                <div>Started On: {{ formatTimestamp(app.start_date) }}</div>
                <!-- <progress id="file" value="25" max="100"></progress> -->
              </div>
            </article>
          </div>
        </div>
        <div v-else-if="currentTab == 'completedActivity'">
          <h2>Complete Activities</h2>
          <div class="activities-grid-completed">
            <article v-for="(app, index) in activityCompletedList" class="completed-activity-container" :key="index" @click="openModal('completed-activity-modal'); tableActivityCompletedObject = app">
              <div>
                <img v-if="app.image" :src="`${reverseProxy}/api/${app.image}`" alt="Picture N/A" loading="lazy"/>
              </div>
              <div>
                <div style="display: flex; align-items: center; column-gap: 5px;">
                  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 8C15 9.06087 14.5786 10.0783 13.8284 10.8284C13.0783 11.5786 12.0609 12 11 12C9.93913 12 8.92172 11.5786 8.17157 10.8284C7.42143 10.0783 7 9.06087 7 8C7 6.93913 7.42143 5.92172 8.17157 5.17157C8.92172 4.42143 9.93913 4 11 4C12.0609 4 13.0783 4.42143 13.8284 5.17157C14.5786 5.92172 15 6.93913 15 8ZM13 8C13 8.53043 12.7893 9.03914 12.4142 9.41421C12.0391 9.78929 11.5304 10 11 10C10.4696 10 9.96086 9.78929 9.58579 9.41421C9.21071 9.03914 9 8.53043 9 8C9 7.46957 9.21071 6.96086 9.58579 6.58579C9.96086 6.21071 10.4696 6 11 6C11.5304 6 12.0391 6.21071 12.4142 6.58579C12.7893 6.96086 13 7.46957 13 8Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM2 11C2 13.09 2.713 15.014 3.908 16.542C4.74744 15.4401 5.83015 14.5471 7.07164 13.9327C8.31312 13.3183 9.6798 12.9991 11.065 13C12.4324 12.9984 13.7821 13.3091 15.0111 13.9084C16.2402 14.5077 17.3162 15.3797 18.157 16.458C19.0234 15.3216 19.6068 13.9952 19.8589 12.5886C20.111 11.182 20.0244 9.73553 19.6065 8.36898C19.1886 7.00243 18.4512 5.75505 17.4555 4.73004C16.4598 3.70503 15.2343 2.93186 13.8804 2.47451C12.5265 2.01716 11.0832 1.88877 9.66986 2.09997C8.25652 2.31117 6.91379 2.85589 5.75277 3.68905C4.59175 4.52222 3.64581 5.61987 2.99323 6.8912C2.34065 8.16252 2.00018 9.57097 2 11ZM11 20C8.93391 20.0033 6.93014 19.2926 5.328 17.988C5.97281 17.0646 6.83119 16.3107 7.83008 15.7905C8.82896 15.2702 9.93876 14.999 11.065 15C12.1772 14.999 13.2735 15.2635 14.263 15.7713C15.2524 16.2792 16.1064 17.0158 16.754 17.92C15.1395 19.267 13.1026 20.0033 11 20Z" fill="black"/>
                  </svg>
                  <span>{{ `${app.first_name} ${app.last_name}` }}</span>
                </div>
                <h5>{{ app.title }}</h5>
                <div>Completed On: {{ formatTimestamp(app.finish_date) }}</div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from '../axios.js';

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        currentTab: 'startActivity',
        purchasesData: null,
        activityResumeList: null,
        activityCompletedList: null,
        tableActivityStartObject: null,
        tableActivityResumeObject: null,
        tableActivityCompletedObject: null,
        childrenList: null,
        startActivityChildInput: '',

        purchaseById: null,
        activityResumeById: null,
      }
    },
    async created() {
      try {
        let purchaseResponse = await instance.get(`/api/user-app-purchased-junction/appJointByUser/${this.$store.getters.getCurrentUser}`);
        this.purchasesData = purchaseResponse.data;
        let activityResumeResponse = await instance.get(`/api/activity/appActivityChildJoint/${this.$store.getters.getCurrentUser}`);
        this.activityResumeList = activityResumeResponse.data.filter(obj => obj.finish_date == null);
        this.activityCompletedList = activityResumeResponse.data.filter(obj => obj.finish_date != null);
        let childrenResponse = await instance.get(`/api/user/children/${this.$store.getters.getCurrentUser}`);
        this.childrenList = childrenResponse.data;
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      changeTab(tab) {
        this.currentTab = tab;
      },
      formatTimestamp(timestamp) {
        if (timestamp == null) {
          return 'null';
        }

        const date = new Date(timestamp);
        const month = date.getMonth() + 1; // Months are zero-based
        const day = date.getDate();
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
      },
      getPercentage(numerator, denominator) {
        if (denominator === 0) {
          return 'Cannot divide by zero';
        }
        
        return Math.round((numerator / denominator) * 100);
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      async startNewActivity() {
        try {
          if (this.startActivityChildInput == '') {
            alert('Please Select a Child');
            return;
          }

          if ((this.tableActivityStartObject-(this.tableActivityStartObject.units_used+1)) < 0) {
            alert('Already Used All Unit');
            return;
          }

          if (this.tableActivityStartObject.purchase_type == 'unit') {
            await instance.patch(`/api/user-app-purchased-junction/${this.tableActivityStartObject.purchase_id}`, {
              units_used: this.tableActivityStartObject.units_used + 1
            });
          }

          let response = await instance.post(`/api/activity`, {
            child_id: this.startActivityChildInput,
            purchase_id: this.tableActivityStartObject.purchase_id,
            total_duration: "0 seconds",
            start_date: new Date().toISOString(),
            finish_date: null
          })
          let responseApp = await instance.get(`/api/question-admin/application/${this.tableActivityStartObject.application_id}`);
          responseApp = responseApp.data;
          let questionResultArray = [];
          for (let i = 0; i < responseApp.length; i++) {
            questionResultArray.push({
              question_reference_id: responseApp[i].question_id,
              activity_id: response.data.activity_id,
              notes: "",
              selected_score: null,
              child_selected_answer: [],
              correct_answer: [],
              audio_clips: [],
              video_clips: [],
              picture_clips: [],
              prompt_clicks: 0,
              repeat_clicks: 0,
              total_duration: "00:00:00",
              ecg: null,
              emg: null,
              motor_sensor_left: null,
              motor_sensor_right: null,
              prompt_count: 0,
              hint_count: 0,
              repeat_count: 0,
              over_time: "00:00:00",
              skipped: false
            });
          }
          await instance.post(`/api/question-result/batch`, questionResultArray);

          this.$router.push(`/activity/${response.data.activity_id}`);
        } catch (e) {
          console.error(e);
        }
      },
      resumeActivityButton() {
        this.$router.push(`/activity/${this.tableActivityResumeObject.activity_id}`);
      },
      completedActivityButton() {
        this.$router.push(`/activity/report/${this.tableActivityCompletedObject.activity_id}`);
      },
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';
  $sidebar-width: 250px;

  progress {
    border-radius: 50rem; 
    height: 8px;

    &::-webkit-progress-bar {
      background-color: #E9E9E9;
      border-radius: 50rem;
    }
    &::-webkit-progress-value {
      background-color: globalSharedVariables.$orange-1;
      border-radius: 50rem;
    }
  }

  #activities-container {
    #sidebar-box {
      width: $sidebar-width;
      position: fixed;
      background-color: #F4F4F4;
      height: calc(100dvh - #{globalSharedVariables.$navbar-height});

      svg {
        width: 16px;
        height: 16px;
      }

      .side-nav-back {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .side-nav {
        font-size: 20px;
        padding: .5rem;
        cursor: pointer;

        &:hover {
          background-color: #C4C4C4;
        }

        &.activeTab {
          background-color: #C4C4C4;
        }
      }
    }

    #main-box {
      margin-left: $sidebar-width;
      padding: 1rem;

      .activities-grid-start {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        column-gap: 5px;
        row-gap: 5px;

        article {
          cursor: pointer;

          &.start-activity-container {
            width: 250px;

            img {
              border-radius: 10px;
              width: 250px;
              height: 150px;
            }

            h6, p {
              margin: 0;
            }
          }
        }
      }

      .activities-grid-resume {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        column-gap: 5px;
        row-gap: 5px;

        article {
          cursor: pointer;

          &.resume-activity-container {
            display: flex;
            flex-wrap: nowrap;
            column-gap: 1rem;

            > div:nth-child(2) {
              display: flex;
              flex-direction: column;
              justify-content: center;
            }

            img {
              border-radius: 10px;
              width: 190px;
              height: 120px;
            }

            svg {
              width: 22px;
              height: 22px;
            }
          }
        }
      }

      .activities-grid-completed {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        column-gap: 5px;
        row-gap: 5px;

        article {
          cursor: pointer;

          &.completed-activity-container {
            display: flex;
            flex-wrap: nowrap;
            column-gap: 1rem;

            > div:nth-child(2) {
              display: flex;
              flex-direction: column;
              justify-content: center;
            }

            img {
              border-radius: 10px;
              width: 190px;
              height: 120px;
            }

            svg {
              width: 22px;
              height: 22px;
            }
          }
        }
      }
    }
  }

  dialog {
    width: 560px;

    h2 {
      text-align: center;
    }

    .long-button {
      width: 100%;
      margin-top: 1rem;
    }
  }

  #start-activity-modal, #resume-activity-modal, #completed-activity-modal {
    .header-container {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      margin-bottom: 1rem;

      > div:nth-child(2) {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      img {
        width: 115px;
        height: 72px;
        border-radius: 10px;
      }
    }
  }

  #start-activity-modal {
    select {
      width: 100%;
    }

    a {
      text-decoration: none;
      color: #886218;
      display: block;
      font-size: .8rem;
      margin-top: 5px;
    }

    button {
      font-size: 20px;
    }

    h3, p {
      margin: 0;
    }

    p {
      color: #946406;
    }
  }

  #resume-activity-modal {
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;

      .columnName {
        color: #707070;
      }

      svg {
        width: 24px;
        height: 24px;
      }
    }
  }

  #completed-activity-modal {
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      .columnName {
        color: #707070;
      }

      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
</style>